// src/components/subscription/MembershipInfo.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { getAuthHeader } from '../../utils/authToken';
import { PLAN_CONFIGS } from './config/constants';
// import { formatCurrency } from '../../utils/currency';
import { formatCurrency } from '../../../utils/currency';

// import ConfirmationDialog from './ConfirmationDialog';
import ConfirmationDialog from '../../restaurants/ConfirmationDialog';

import axios from 'axios';
// src/components/subscription/MembershipInfo.jsx
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// src/components/subscription/PaymentMethodsSection.jsx
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

// const token = localStorage.getItem('ownerToken');

// const TransactionRow = ({ transaction }) => {
//   const downloadButton = () => {
//     if (transaction.invoiceUrl || transaction.receiptUrl) {
//       return (
//         <button
//           onClick={() =>
//             window.open(
//               transaction.invoiceUrl || transaction.receiptUrl,
//               '_blank'
//             )
//           }
//           className='text-blue-500 hover:text-blue-700'
//         >
//           {transaction.invoiceUrl ? 'Download Invoice' : 'View Receipt'}
//         </button>
//       );
//     }
//     return null;
//   };

const PaymentMethodsSection = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [defaultPaymentMethodId, setDefaultPaymentMethodId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddCard, setShowAddCard] = useState(false);
  const [addingCard, setAddingCard] = useState(false);
  const [setupIntent, setSetupIntent] = useState(null);

  const stripe = useStripe();
  const elements = useElements();

  const [authToken, setAuthToken] = useState(
    localStorage.getItem('ownerToken')
  );

  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = () => {
      const newToken = localStorage.getItem('ownerToken');
      setAuthToken(newToken);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  // Reset card element when form is hidden
  useEffect(() => {
    if (!showAddCard && elements) {
      const cardElement = elements.getElement(CardElement);
      if (cardElement) {
        cardElement.clear();
      }
    }
  }, [showAddCard, elements]);

  const fetchPaymentMethods = async () => {
    try {
      const response = await api.get('/subscriptions/payment-methods', {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      setPaymentMethods(response.data.paymentMethods);
      setSetupIntent(response.data.setupIntent);
      if (response.data.defaultPaymentMethod) {
        setDefaultPaymentMethodId(response.data.defaultPaymentMethod.id);
      }
    } catch (error) {
      console.error('Error fetching payment methods:', error);
      setError('Failed to load payment methods');
    } finally {
      setIsLoading(false);
    }
  };
  const handleAddNewCard = async (e) => {
    e.preventDefault();

    if (!stripe || !elements || addingCard) return;

    setAddingCard(true);
    try {
      const { error: submitError } = await elements.submit();
      if (submitError) {
        throw submitError;
      }

      const { error, setupIntent: confirmedSetup } =
        await stripe.confirmCardSetup(setupIntent, {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        });

      if (error) {
        throw error;
      }

      // If this is the first payment method, set it as default
      if (paymentMethods.length === 0) {
        try {
          await api.put(
            `/subscriptions/payment-methods/${confirmedSetup.payment_method}`,
            { isDefault: true },
            { headers: { Authorization: `Bearer ${authToken}` } }
          );
        } catch (defaultError) {
          console.error('Error setting default payment method:', defaultError);
          // Don't throw here - the card was still added successfully
        }
      }

      // Refresh payment methods list
      await fetchPaymentMethods();
      setShowAddCard(false);
      toast.success('Card added successfully');
    } catch (error) {
      console.error('Error adding card:', error);
      toast.error(error.message || 'Failed to add card');
    } finally {
      setAddingCard(false);
    }
  };
  const handleDeletePaymentMethod = async (methodId) => {
    if (
      !window.confirm('Are you sure you want to delete this payment method?')
    ) {
      return;
    }

    try {
      await api.delete(`/subscriptions/payment-methods/${methodId}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      await fetchPaymentMethods();
      toast.success('Payment method deleted successfully');
    } catch (error) {
      console.error('Error deleting payment method:', error);
      toast.error(
        error.response?.data?.error || 'Failed to delete payment method'
      );
    }
  };

  const handleSetDefaultPaymentMethod = async (methodId) => {
    try {
      await api.put(
        `/subscriptions/payment-methods/${methodId}`,
        { isDefault: true },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      await fetchPaymentMethods();
      toast.success('Default payment method updated');
    } catch (error) {
      console.error('Error updating default payment method:', error);
      toast.error(
        error.response?.data?.error || 'Failed to update default payment method'
      );
    }
  };

  if (isLoading) {
    return (
      <div className='flex justify-center items-center min-h-8 mt-8'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500' />
      </div>
    );
  }

  if (error) {
    return <div className='text-red-500 py-4'>{error}</div>;
  }

  return (
    <div className='bg-white rounded-lg shadow-md p-6 mt-8'>
      <div className='flex justify-between items-center mb-6'>
        <h2 className='text-xl font-bold'>Payment Methods</h2>
        <button
          onClick={() => setShowAddCard(!showAddCard)}
          className='text-blue-500 hover:text-blue-700'
        >
          {showAddCard ? 'Cancel' : 'Add New Card'}
        </button>
      </div>

      {/* Add New Card Form */}
      {showAddCard && (
        <form onSubmit={handleAddNewCard} className='mb-6'>
          <div className='mb-4'>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Card Details
            </label>
            <div className='border rounded-md p-4'>
              <CardElement
                options={{
                  style: {
                    base: {
                      fontSize: '16px',
                      color: '#424770',
                      '::placeholder': {
                        color: '#aab7c4',
                      },
                    },
                    invalid: {
                      color: '#9e2146',
                    },
                  },
                }}
              />
            </div>
          </div>
          <button
            type='submit'
            disabled={addingCard || !stripe}
            className='w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 
                     disabled:opacity-50 disabled:cursor-not-allowed'
          >
            {addingCard ? 'Adding...' : 'Add Card'}
          </button>
        </form>
      )}

      {/* Existing Payment Methods */}
      {paymentMethods.length === 0 && !showAddCard ? (
        <>
          <p className='text-gray-500'>No payment methods found</p>
          <p className='text-sm text-yellow-700'>
            No default payment method set. Please add a payment method to avoid
            service interruption.
          </p>
        </>
      ) : (
        <div className='space-y-4'>
          {paymentMethods.map((method) => (
            <div key={method.id} className='border rounded-lg p-4'>
              {/* <div className='flex justify-between items-center'> */}
              <div className='flex flex-col sm:flex-row sm:items-center gap-4'>
                <div>
                  <p className='font-medium flex items-center gap-2'>
                    {method.card.brand.toUpperCase()} •••• {method.card.last4}
                    {method.id === defaultPaymentMethodId && (
                      <span className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800'>
                        Default
                      </span>
                    )}
                  </p>
                  <p className='text-sm text-gray-600'>
                    Expires {method.card.exp_month}/{method.card.exp_year}
                  </p>
                </div>
                {/* <div className='flex items-center gap-2'> */}
                <div className='flex flex-col sm:flex-row items-stretch sm:items-center gap-2'>
                  {method.id !== defaultPaymentMethodId && (
                    <button
                      onClick={() => handleSetDefaultPaymentMethod(method.id)}
                      // className='px-3 py-1 text-sm text-blue-600 hover:text-blue-800'
                      className='px-3 py-1 text-sm text-blue-600 hover:text-blue-800 text-center border border-blue-600 rounded'
                    >
                      Set as Default
                    </button>
                  )}
                  {/* <button
                    onClick={() => handleDeletePaymentMethod(method.id)}
                    disabled={method.id === defaultPaymentMethodId}
                    className={`px-3 py-1 text-sm ${
                      method.id === defaultPaymentMethodId
                        ? 'text-gray-400 cursor-not-allowed'
                        : 'text-red-600 hover:text-red-800'
                    }`}
                    title={
                      method.id === defaultPaymentMethodId
                        ? 'Cannot delete default payment method'
                        : 'Delete payment method'
                    }
                  >
                    Delete
                  </button> */}
                  <button
                    onClick={() => handleDeletePaymentMethod(method.id)}
                    // className='px-3 py-1 text-sm text-red-600 hover:text-red-800'
                    className='px-3 py-1 text-sm text-red-600 hover:text-red-800 text-center border border-red-600 rounded'
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const TransactionRow = ({ transaction }) => {
  // // Add debug logging
  // console.log('Transaction in row:', transaction);
  // console.log('Receipt URL:', transaction.receiptUrl);
  // console.log('Invoice URL:', transaction.invoiceUrl);

  const downloadButton = () => {
    // Add debug logging
    // console.log('Checking URLs for download button:', {
    //   invoiceUrl: transaction.invoiceUrl,
    //   receiptUrl: transaction.receiptUrl,
    // });

    if (transaction.invoiceUrl || transaction.receiptUrl) {
      return (
        <button
          onClick={() =>
            window.open(
              transaction.invoiceUrl || transaction.receiptUrl,
              '_blank'
            )
          }
          className='text-blue-500 hover:text-blue-700'
        >
          {transaction.invoiceUrl ? 'Download Invoice' : 'View Receipt'}
        </button>
      );
    }
    return null;
  };

  return (
    <tr>
      <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
        {new Date(transaction.createdAt).toLocaleDateString()}
      </td>
      <td className='px-6 py-4 text-sm text-gray-900'>
        {transaction.description}
        {transaction.metadata?.isDowngrade && (
          <span className='block text-xs text-orange-500 mt-1'>
            Changes effective{' '}
            {new Date(transaction.metadata.effectiveDate).toLocaleDateString()}
          </span>
        )}
      </td>
      <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
        {formatCurrency(transaction.amount / 100)}
      </td>
      <td className='px-6 py-4 whitespace-nowrap'>
        <span
          className={`px-2 py-1 text-xs font-semibold rounded-full ${
            transaction.status === 'completed'
              ? 'bg-green-100 text-green-800'
              : transaction.status === 'failed'
              ? 'bg-red-100 text-red-800'
              : 'bg-gray-100 text-gray-800'
          }`}
        >
          {transaction.status}
        </span>
      </td>
      <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
        {downloadButton()}
      </td>
    </tr>
  );
};

const MembershipInfoContent = () => {
  const [subscription, setSubscription] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [downloadingInvoice, setDownloadingInvoice] = useState(false);

  const [authToken, setAuthToken] = useState(
    localStorage.getItem('ownerToken')
  );

  const navigate = useNavigate();

  // Listen for auth changes
  useEffect(() => {
    const token = localStorage.getItem('ownerToken');
    setAuthToken(token);

    // Reset states when token changes
    if (token !== authToken) {
      setSubscription(null);
      setTransactions([]);
      // Reset other states as needed
    }
  }, [authToken]);

  useEffect(() => {
    const handleStorageChange = () => {
      const newToken = localStorage.getItem('ownerToken');
      setAuthToken(newToken);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // // Modify data fetching to use authToken
  // const fetchData = async () => {
  //   if (!authToken) {
  //     setLoading(false);
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     // Fetch subscription and transactions in parallel
  //     const [subscriptionResponse, transactionsResponse] = await Promise.all([
  //       api.get('/subscriptions/current', {
  //         headers: { Authorization: `Bearer ${authToken}` },
  //       }),
  //       api.get(`/subscriptions/transactions?page=${currentPage}`, {
  //         headers: { Authorization: `Bearer ${authToken}` },
  //       }),
  //     ]);

  //     setSubscription(subscriptionResponse.data);
  //     setTransactions(transactionsResponse.data.transactions);
  //     setTotalPages(transactionsResponse.data.totalPages);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     toast.error('Failed to load data');
  //     // Clear data on error
  //     setSubscription(null);
  //     setTransactions([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // useEffect(() => {
  // //   fetchSubscriptionData();
  // // }, []);

  // // Update useEffect to depend on authToken
  // useEffect(() => {
  //   let mounted = true;

  //   const loadData = async () => {
  //     if (!mounted) return;
  //     await fetchData();
  //   };

  //   loadData();

  //   return () => {
  //     mounted = false;
  //   };
  // }, [authToken, currentPage]);

  const fetchData = useCallback(async () => {
    if (!authToken) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const [subscriptionResponse, transactionsResponse] = await Promise.all([
        api.get('/subscriptions/current', {
          headers: { Authorization: `Bearer ${authToken}` },
        }),
        api.get(`/subscriptions/transactions?page=${currentPage}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        }),
      ]);

      setSubscription(subscriptionResponse.data);
      setTransactions(transactionsResponse.data.transactions);
      setTotalPages(transactionsResponse.data.totalPages);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to load data');
      setSubscription(null);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  }, [authToken, currentPage]); // Add dependencies

  useEffect(() => {
    if (authToken) {
      fetchData();
    }
  }, [fetchData]); // Only depend on fetchData

  // useEffect(() => {
  //   if (!loading) {
  //     fetchTransactions(currentPage);
  //   }
  // }, [currentPage, loading]);

  // const fetchSubscriptionData = async () => {
  //   try {
  //     const token = localStorage.getItem('ownerToken');

  //     const response = await api.get('/subscriptions/current', {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     setSubscription(response.data);
  //   } catch (error) {
  //     console.error('Error fetching subscription:', error);
  //     toast.error('Failed to load subscription details');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchTransactions = async (page) => {
  //   try {
  //     const response = await api.get(
  //       `/subscriptions/transactions?page=${page}`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     setTransactions(response.data.transactions);
  //     setTotalPages(response.data.totalPages);
  //   } catch (error) {
  //     console.error('Error fetching transactions:', error);
  //     toast.error('Failed to load transaction history');
  //   }
  // };

  // const fetchTransactions = async (page) => {
  //   try {
  //     const token = localStorage.getItem('ownerToken');
  //     const response = await api.get(
  //       `/subscriptions/transactions?page=${page}`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     // Add debug logging
  //     console.log('Transactions from API:', response.data.transactions);

  //     setTransactions(response.data.transactions);
  //     setTotalPages(response.data.totalPages);
  //   } catch (error) {
  //     console.error('Error fetching transactions:', error);
  //     toast.error('Failed to load transaction history');
  //   }
  // };

  const handleCancelSubscription = async () => {
    try {
      await api.post(
        '/subscriptions/cancel',
        {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      toast.success(
        'Subscription will be canceled at the end of the billing period'
      );
      setShowCancelDialog(false);
      await fetchData();
    } catch (error) {
      console.error('Error canceling subscription:', error);
      toast.error('Failed to cancel subscription');
    }
  };

  const handleReactivate = async () => {
    try {
      await api.post(
        '/subscriptions/reactivate',
        {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      toast.success('Subscription reactivated successfully');
      await fetchData();
    } catch (error) {
      console.error('Error reactivating subscription:', error);
      toast.error('Failed to reactivate subscription');
    }
  };

  // const handleDownloadInvoice = async (invoiceId) => {
  //   setDownloadingInvoice(invoiceId);
  //   try {
  //     const response = await api.get(`/subscriptions/invoices/${invoiceId}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //       responseType: 'blob',
  //     });

  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', `invoice-${invoiceId}.pdf`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error('Error downloading invoice:', error);
  //     toast.error('Failed to download invoice');
  //   } finally {
  //     setDownloadingInvoice(null);
  //   }
  // };
  const handleDownloadInvoice = async (invoiceId) => {
    setDownloadingInvoice(invoiceId);
    try {
      const response = await api.get(`/subscriptions/invoices/${invoiceId}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      // Open the invoice URL in a new tab
      if (response.data.invoiceUrl) {
        window.open(response.data.invoiceUrl, '_blank');
      }
    } catch (error) {
      console.error('Error downloading invoice:', error);
      toast.error('Failed to download invoice');
    } finally {
      setDownloadingInvoice(null);
    }
  };

  const handleCancelDowngrade = async () => {
    try {
      await api.delete('/subscriptions/downgrade', {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      toast.success('Pending downgrade cancelled');
      await fetchData();
    } catch (error) {
      console.error('Error cancelling downgrade:', error);
      toast.error('Failed to cancel downgrade');
    }
  };

  const renderPlanFeatures = () => {
    // For free users or when subscription is null
    if (!subscription || subscription.planType === 'free') {
      return (
        <li className='flex items-center text-sm'>
          <svg
            className='w-4 h-4 mr-2 text-green-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M5 13l4 4L19 7'
            />
          </svg>
          Basic access
        </li>
      );
    }

    // For paid plans
    return PLAN_CONFIGS[subscription.planType]?.features?.map(
      (feature, index) => (
        <li key={index} className='flex items-center text-sm'>
          <svg
            className='w-4 h-4 mr-2 text-green-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M5 13l4 4L19 7'
            />
          </svg>
          {feature}
        </li>
      )
    );
  };

  if (loading) {
    return (
      <div className='flex justify-center items-center min-h-screen'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500' />
      </div>
    );
  }

  return (
    <div className='container mx-auto px-4 py-8 max-w-6xl'>
      {/* Payment Status Warnings */}
      {/* {subscription?.status === 'past_due' && (
        <div className='bg-red-50 border-l-4 border-red-500 p-4 mb-6'>
          <div className='flex'>
            <div className='flex-shrink-0'>
              <svg
                className='h-5 w-5 text-red-400'
                viewBox='0 0 20 20'
                fill='currentColor'
              >
                <path
                  fillRule='evenodd'
                  d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
                  clipRule='evenodd'
                />
              </svg>
            </div>
            <div className='ml-3'>
              <h3 className='text-sm font-medium text-red-800'>
                Payment Failed
              </h3>
              <div className='mt-2 text-sm text-red-700'>
                <p>
                  Your last payment attempt failed. Next retry:{' '}
                  {new Date(
                    subscription.nextPaymentRetryAt
                  ).toLocaleDateString()}
                  . Please update your payment method to avoid service
                  interruption.
                </p>
                <button
                  onClick={() => navigate('/subscription/payment-methods')}
                  className='mt-2 text-red-800 font-semibold hover:text-red-900'
                >
                  Update Payment Method →
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {/* 
      {subscription?.status === 'unpaid' && (
        <div className='bg-red-50 border-l-4 border-red-500 p-4 mb-6'>
          <div className='flex'>
            <div className='ml-3'>
              <h3 className='text-sm font-medium text-red-800'>
                Subscription Unpaid
              </h3>
              <div className='mt-2 text-sm text-red-700'>
                <p>
                  Your subscription has been marked as unpaid due to multiple
                  failed payment attempts. Your plan will be changed to free at
                  the end of the current billing period. Please add a valid
                  payment method to continue your subscription.
                </p>
                <button
                  onClick={() => navigate('/subscription/payment-methods')}
                  className='mt-2 text-red-800 font-semibold hover:text-red-900'
                >
                  Update Payment Method →
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* Current Plan Info */}
      <div className='bg-white rounded-lg shadow-md p-6 mb-8'>
        {/* <div className='flex justify-between items-start mb-6'> */}
        <div className='flex justify-between items-start mb-6 flex-col sm:flex-row gap-4 sm:gap-0'>
          <div>
            <h2 className='text-2xl font-bold'>
              {subscription?.planType && subscription.planType !== 'free'
                ? PLAN_CONFIGS[subscription.planType]?.name
                : 'Free Plan'}
            </h2>
            {subscription?.status === 'active' &&
              subscription.planType !== 'free' && (
                <p className='text-gray-600'>
                  {formatCurrency(
                    PLAN_CONFIGS[subscription.planType]?.prices[
                      subscription.currency
                    ] / 100
                  )}
                  /month
                </p>
              )}
            {/* <div className='mt-2'>
              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium
                ${
                  subscription?.status === 'active'
                    ? 'bg-green-100 text-green-800'
                    : subscription?.status === 'past_due'
                    ? 'bg-yellow-100 text-yellow-800'
                    : subscription?.status === 'unpaid'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-gray-100 text-gray-800'
                }`}
              >
                {subscription?.status === 'active'
                  ? 'Active'
                  : subscription?.status === 'past_due'
                  ? 'Payment Due'
                  : subscription?.status === 'unpaid'
                  ? 'Unpaid'
                  : 'Inactive'}
              </span>
            </div> */}
          </div>
          {/* <div className='space-x-4'> */}
          <div className='flex flex-col sm:flex-row gap-2 sm:space-x-4 w-full sm:w-auto'>
            <button
              onClick={() => navigate('/owner/test/membershipplans')}
              // className='bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600'
              className='bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 text-center'
            >
              {subscription?.planType && subscription.planType !== 'free'
                ? 'Change Plan'
                : 'Upgrade'}{' '}
            </button>
            {subscription?.status === 'active' &&
              subscription.planType !== 'free' &&
              !subscription.pendingAction && (
                <button
                  onClick={() => setShowCancelDialog(true)}
                  // className='text-red-500 hover:text-red-700'
                  className='text-red-500 hover:text-red-700 text-center py-2'
                >
                  Cancel Subscription
                </button>
              )}
            {subscription?.pendingAction === 'cancel' && (
              <button
                onClick={handleReactivate}
                // className='text-blue-500 hover:text-blue-700'
                className='text-blue-500 hover:text-blue-700 text-center py-2'
              >
                Reactivate Subscription
              </button>
            )}
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
          <div className='bg-gray-50 p-4 rounded'>
            <h3 className='font-semibold mb-2'>Credits</h3>
            <div className='space-y-1'>
              <p>
                Subscription Credits: {subscription?.credits?.subscription || 0}
              </p>
              <p>Purchased Credits: {subscription?.credits?.purchased || 0}</p>
              <p className='font-medium'>
                Total Available:{' '}
                {(subscription?.credits?.subscription || 0) +
                  (subscription?.credits?.purchased || 0)}
              </p>
            </div>
            <button
              onClick={() => navigate('/owner/test/credits')}
              className='mt-4 text-blue-500 hover:text-blue-700'
            >
              Buy More Credits
            </button>
          </div>

          {/* <div className='bg-gray-50 p-4 rounded'>
            <h3 className='font-semibold mb-2'>Billing Period</h3>
            <div className='space-y-1'>
              <p>
                Current Period:{' '}
                {new Date(
                  subscription?.currentPeriodStart
                ).toLocaleDateString()}{' '}
                -{' '}
                {new Date(subscription?.currentPeriodEnd).toLocaleDateString()}
              </p>
              {subscription?.pendingAction === 'cancel' && (
                <p className='text-red-500'>
                  Cancels on{' '}
                  {new Date(subscription.currentPeriodEnd).toLocaleDateString()}
                </p>
              )} */}
          {/* {subscription?.pendingAction === 'downgrade' && (
                <p className='text-orange-500'>
                  Changes to {PLAN_CONFIGS[subscription.pendingPlan].name} on{' '}
                  {new Date(subscription.currentPeriodEnd).toLocaleDateString()}
                </p>
              )} */}
          {/* {subscription?.pendingAction === 'downgrade' && (
                <>
                  <p className='text-orange-500'>
                    Changes to {PLAN_CONFIGS[subscription.pendingPlan].name} on{' '}
                    {new Date(
                      subscription.currentPeriodEnd
                    ).toLocaleDateString()}
                  </p>
                  <button
                    onClick={handleCancelDowngrade}
                    className='text-blue-500 hover:text-blue-700'
                  >
                    Cancel Downgrade
                  </button>
                </>
              )} */}
          {/* {subscription?.paymentFailureCount > 0 && (
                <p className='text-red-500'>
                  Failed Payments: {subscription.paymentFailureCount}
                  {subscription.nextPaymentRetryAt && (
                    <span className='ml-2'>
                      (Next retry:{' '}
                      {new Date(
                        subscription.nextPaymentRetryAt
                      ).toLocaleDateString()}
                      )
                    </span>
                  )}
                </p>
              )} */}
          {/* </div>
          </div> */}

          {/* Billing Period Section - Only show for paid plans */}
          {subscription?.planType !== 'free' && (
            <div className='bg-gray-50 p-4 rounded'>
              <h3 className='font-semibold mb-2'>Billing Period</h3>
              <div className='space-y-1'>
                <p>
                  Current Period:{' '}
                  {subscription?.currentPeriodStart
                    ? `${new Date(
                        subscription.currentPeriodStart
                      ).toLocaleDateString()} - ${new Date(
                        subscription.currentPeriodEnd
                      ).toLocaleDateString()}`
                    : 'N/A'}
                </p>
                {subscription?.pendingAction === 'cancel' && (
                  <p className='text-red-500'>
                    Cancels on{' '}
                    {new Date(
                      subscription.currentPeriodEnd
                    ).toLocaleDateString()}
                  </p>
                )}
                {subscription?.pendingAction === 'downgrade' && (
                  <div>
                    <p className='text-orange-500'>
                      Changes to {subscription.pendingPlan} on{' '}
                      {new Date(
                        subscription.currentPeriodEnd
                      ).toLocaleDateString()}
                    </p>
                    <button
                      onClick={handleCancelDowngrade}
                      className='text-blue-500 hover:text-blue-700'
                    >
                      Cancel Downgrade
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className='bg-gray-50 p-4 rounded'>
            <h3 className='font-semibold mb-2'>Features</h3>
            <ul className='space-y-1'>
              {/* {subscription?.planType &&
                PLAN_CONFIGS[subscription.planType]?.features?.map(
                  (feature, index) => (
                    <li key={index} className='flex items-center text-sm'>
                      <svg
                        className='w-4 h-4 mr-2 text-green-500'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth={2}
                          d='M5 13l4 4L19 7'
                        />
                      </svg>
                      {feature}
                    </li>
                  )
                )} */}
              {renderPlanFeatures()}
            </ul>
          </div>
        </div>
        {/* </div> */}

        {/* Payment Method Warning */}
        {/* {!subscription?.defaultPaymentMethod &&
          subscription?.status === 'active' && (
            <div className='mt-6 bg-yellow-50 border-l-4 border-yellow-400 p-4'>
              <div className='flex'>
                <div className='ml-3'>
                  <p className='text-sm text-yellow-700'>
                    No default payment method set. Please add a payment method
                    to avoid service interruption.
                  </p>
                  <button
                    onClick={() => navigate('/subscription/payment-methods')}
                    className='mt-2 text-yellow-700 font-semibold hover:text-yellow-900'
                  >
                    Add Payment Method →
                  </button>
                </div>
              </div>
            </div>
          )} */}
        {/* Payment Methods Section */}
        <div className='mb-8'>
          <PaymentMethodsSection />
        </div>
      </div>

      {/* Transaction History */}
      <div className='bg-white rounded-lg shadow-md p-6'>
        <h2 className='text-xl font-bold mb-6'>Transaction History</h2>

        {transactions?.length === 0 ? (
          <p className='text-gray-500 text-center py-8'>
            No transactions found
          </p>
        ) : (
          // <>
          //   <div className='overflow-x-auto'>
          //     <table className='min-w-full divide-y divide-gray-200'>
          //       <thead className='bg-gray-50'>
          //         <tr>
          //           <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
          //             Date
          //           </th>
          //           <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
          //             Description
          //           </th>
          //           <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
          //             Amount
          //           </th>
          //           <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
          //             Status
          //           </th>
          //           <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
          //             Receipt
          //           </th>
          //         </tr>
          //       </thead>
          //       {/* <tbody className='bg-white divide-y divide-gray-200'>
          //         {transactions.map((transaction) => (
          //           <tr key={transaction.id}>
          //             <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
          //               {new Date(transaction.createdAt).toLocaleDateString()}
          //             </td>
          //             <td className='px-6 py-4 text-sm text-gray-900'>
          //               {transaction.description}
          //               {transaction.metadata?.isDowngrade && (
          //                 <span className='ml-2 text-orange-500'>
          //                   (Changes effective{' '}
          //                   {new Date(
          //                     transaction.metadata.effectiveDate
          //                   ).toLocaleDateString()}
          //                   )
          //                 </span>
          //               )}
          //               {transaction.metadata?.failureReason && (
          //                 <span className='ml-2 text-red-500'>
          //                   ({transaction.metadata.failureReason})
          //                 </span>
          //               )}
          //             </td>
          //             <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
          //               {formatCurrency(transaction.amount / 100)}
          //             </td>
          //             <td className='px-6 py-4 whitespace-nowrap'>
          //               <span
          //                 className={`px-2 py-1 text-xs font-semibold rounded-full
          //                 ${
          //                   transaction.status === 'completed'
          //                     ? 'bg-green-100 text-green-800'
          //                     : transaction.status === 'failed'
          //                     ? 'bg-red-100 text-red-800'
          //                     : 'bg-gray-100 text-gray-800'
          //                 }`}
          //               >
          //                 {transaction.status}
          //               </span>
          //             </td>
          //             <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
          //               {transaction.stripeInvoiceId && (
          //                 <button
          //                   onClick={() =>
          //                     handleDownloadInvoice(transaction.stripeInvoiceId)
          //                   }
          //                   disabled={
          //                     downloadingInvoice === transaction.stripeInvoiceId
          //                   }
          //                   className='text-blue-500 hover:text-blue-700 disabled:opacity-50'
          //                 >
          //                   {downloadingInvoice === transaction.stripeInvoiceId
          //                     ? 'Downloading...'
          //                     : 'Download'}
          //                 </button>
          //               )}
          //             </td>
          //           </tr>
          //         ))}
          //       </tbody> */}
          //       <tbody className='bg-white divide-y divide-gray-200'>
          //         {transactions.map((transaction) => (
          //           <TransactionRow
          //             key={transaction._id}
          //             transaction={transaction}
          //           />
          //         ))}
          //       </tbody>
          //     </table>
          //   </div>

          //   {/* Pagination */}
          //   {/* {totalPages > 1 && (
          //     <div className='flex justify-center mt-6'>
          //       <nav className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'>
          //         {Array.from({ length: totalPages }).map((_, i) => (
          //           <button
          //             key={i}
          //             onClick={() => setCurrentPage(i + 1)}
          //             className={`relative inline-flex items-center px-4 py-2 text-sm font-medium
          //               ${
          //                 currentPage === i + 1
          //                   ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
          //                   : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
          //               } border`}
          //           >
          //             {i + 1}
          //           </button>
          //         ))}
          //       </nav>
          //     </div>
          //   )} */}
          //   {/* Pagination */}
          //   {totalPages > 1 && (
          //     <div className='flex justify-center mt-6'>
          //       <nav className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'>
          //         <button
          //           onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
          //           disabled={currentPage === 1}
          //           className='relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
          //         >
          //           Previous
          //         </button>
          //         {Array.from({ length: totalPages }).map((_, i) => (
          //           <button
          //             key={i}
          //             onClick={() => setCurrentPage(i + 1)}
          //             className={`relative inline-flex items-center px-4 py-2 text-sm font-medium
          //           ${
          //             currentPage === i + 1
          //               ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
          //               : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
          //           } border`}
          //           >
          //             {i + 1}
          //           </button>
          //         ))}
          //         <button
          //           onClick={() =>
          //             setCurrentPage(Math.min(totalPages, currentPage + 1))
          //           }
          //           disabled={currentPage === totalPages}
          //           className='relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
          //         >
          //           Next
          //         </button>
          //       </nav>
          //     </div>
          //   )}
          // </>

          <>
            {/* Desktop View */}
            <div className='hidden md:block overflow-x-auto'>
              <table className='min-w-full divide-y divide-gray-200'>
                <thead className='bg-gray-50'>
                  <tr>
                    <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
                      Date
                    </th>
                    <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
                      Description
                    </th>
                    <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
                      Amount
                    </th>
                    <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
                      Status
                    </th>
                    <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>
                      Receipt
                    </th>
                  </tr>
                </thead>
                <tbody className='bg-white divide-y divide-gray-200'>
                  {transactions.map((transaction) => (
                    <TransactionRow
                      key={transaction._id}
                      transaction={transaction}
                    />
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile View */}
            <div className='md:hidden space-y-4'>
              {transactions.map((transaction) => (
                <div
                  key={transaction._id}
                  className='bg-gray-50 p-4 rounded-lg space-y-2'
                >
                  <div className='flex justify-between'>
                    <span className='text-sm text-gray-500'>
                      {new Date(transaction.createdAt).toLocaleDateString()}
                    </span>
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded-full
                    ${
                      transaction.status === 'completed'
                        ? 'bg-green-100 text-green-800'
                        : transaction.status === 'failed'
                        ? 'bg-red-100 text-red-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}
                    >
                      {transaction.status}
                    </span>
                  </div>
                  <p className='text-sm'>{transaction.description}</p>
                  {transaction.metadata?.isDowngrade && (
                    <p className='text-xs text-orange-500'>
                      Changes effective{' '}
                      {new Date(
                        transaction.metadata.effectiveDate
                      ).toLocaleDateString()}
                    </p>
                  )}
                  <div className='flex justify-between items-center'>
                    <span className='font-medium'>
                      {formatCurrency(transaction.amount / 100)}
                    </span>
                    {(transaction.invoiceUrl || transaction.receiptUrl) && (
                      <button
                        onClick={() =>
                          window.open(
                            transaction.invoiceUrl || transaction.receiptUrl,
                            '_blank'
                          )
                        }
                        className='text-blue-500 hover:text-blue-700 text-sm'
                      >
                        {transaction.invoiceUrl
                          ? 'Download Invoice'
                          : 'View Receipt'}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination - Make it responsive */}
            {totalPages > 1 && (
              <div className='flex justify-center mt-6 px-2'>
                <nav className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'>
                  <button
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    className='relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
                  >
                    Previous
                  </button>
                  <div className='hidden sm:flex'>
                    {Array.from({ length: totalPages }).map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentPage(i + 1)}
                        className={`relative inline-flex items-center px-4 py-2 text-sm font-medium
                      ${
                        currentPage === i + 1
                          ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                          : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                      } border`}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                  <div className='sm:hidden flex items-center px-4 border-t border-b border-gray-300 bg-white'>
                    <span className='text-sm text-gray-700'>
                      Page {currentPage} of {totalPages}
                    </span>
                  </div>
                  <button
                    onClick={() =>
                      setCurrentPage(Math.min(totalPages, currentPage + 1))
                    }
                    disabled={currentPage === totalPages}
                    className='relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
                  >
                    Next
                  </button>
                </nav>
              </div>
            )}
          </>
        )}
      </div>

      {/* Cancel Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={showCancelDialog}
        onClose={() => setShowCancelDialog(false)}
        onConfirm={handleCancelSubscription}
        title='Cancel Subscription'
      >
        <div className='space-y-4'>
          <p>
            Are you sure you want to cancel your subscription? Your subscription
            will remain active until the end of your current billing period on{' '}
            {new Date(subscription?.currentPeriodEnd).toLocaleDateString()}.
          </p>
          <p className='text-sm text-gray-600'>
            After cancellation:
            <ul className='list-disc ml-5 mt-2'>
              <li>
                Your subscription will remain active until{' '}
                {new Date(subscription?.currentPeriodEnd).toLocaleDateString()}
              </li>
              <li>You'll still have access to all features until then</li>
              <li>No further charges will be made</li>
              <li>Remaining credits will be lost at the end of the period</li>
            </ul>
          </p>
        </div>
      </ConfirmationDialog>
    </div>
  );
};

const MembershipInfo = () => {
  return (
    <Elements stripe={stripePromise}>
      <MembershipInfoContent />
    </Elements>
  );
};

export default MembershipInfo;

// export default MembershipInfo;

// // src/components/subscription/MembershipInfo.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import api from '../../utils/api';
// import { getAuthHeader } from '../../utils/authToken';
// import { PLAN_CONFIGS } from '../../config/constants';
// import { formatCurrency } from '../../utils/currency';
// import ConfirmationDialog from '../common/ConfirmationDialog';

// const MembershipInfo = () => {
//   const [subscription, setSubscription] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showCancelDialog, setShowCancelDialog] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [downloadingInvoice, setDownloadingInvoice] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchSubscriptionData();
//   }, []);

//   useEffect(() => {
//     fetchTransactions(currentPage);
//   }, [currentPage]);

//   const fetchSubscriptionData = async () => {
//     try {
//       const response = await api.get('/subscriptions/current', {
//         headers: getAuthHeader('ownerToken')
//       });
//       setSubscription(response.data);
//     } catch (error) {
//       console.error('Error fetching subscription:', error);
//       toast.error('Failed to load subscription details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTransactions = async (page) => {
//     try {
//       const response = await api.get(`/subscriptions/transactions?page=${page}`, {
//         headers: getAuthHeader('ownerToken')
//       });
//       setTransactions(response.data.transactions);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.error('Error fetching transactions:', error);
//       toast.error('Failed to load transaction history');
//     }
//   };

//   const handleCancelSubscription = async () => {
//     try {
//       await api.post('/subscriptions/cancel', {}, {
//         headers: getAuthHeader('ownerToken')
//       });
//       toast.success('Subscription will be canceled at the end of the billing period');
//       setShowCancelDialog(false);
//       await fetchSubscriptionData();
//     } catch (error) {
//       console.error('Error canceling subscription:', error);
//       toast.error('Failed to cancel subscription');
//     }
//   };

//   const handleReactivate = async () => {
//     try {
//       await api.post('/subscriptions/reactivate', {}, {
//         headers: getAuthHeader('ownerToken')
//       });
//       toast.success('Subscription reactivated successfully');
//       await fetchSubscriptionData();
//     } catch (error) {
//       console.error('Error reactivating subscription:', error);
//       toast.error('Failed to reactivate subscription');
//     }
//   };

//   const handleDownloadInvoice = async (invoiceId) => {
//     setDownloadingInvoice(invoiceId);
//     try {
//       const response = await api.get(`/subscriptions/invoices/${invoiceId}`, {
//         headers: getAuthHeader('ownerToken'),
//         responseType: 'blob'
//       });

//       // Create blob link to download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `invoice-${invoiceId}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error('Error downloading invoice:', error);
//       toast.error('Failed to download invoice');
//     } finally {
//       setDownloadingInvoice(null);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"/>
//       </div>
//     );
//   }

//   return (
//     <div className="container mx-auto px-4 py-8 max-w-6xl">
//       {/* Current Plan Info */}
//       <div className="bg-white rounded-lg shadow-md p-6 mb-8">
//         <div className="flex justify-between items-start mb-6">
//           <div>
//             <h2 className="text-2xl font-bold">
//               {subscription?.planType ? PLAN_CONFIGS[subscription.planType].name : 'Free Plan'}
//             </h2>
//             {subscription?.status === 'active' && (
//               <p className="text-gray-600">
//                 {formatCurrency(PLAN_CONFIGS[subscription.planType].prices[subscription.currency] / 100)}/month
//               </p>
//             )}
//           </div>
//           <div className="space-x-4">
//             <button
//               onClick={() => navigate('/subscription/plans')}
//               className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//             >
//               {subscription?.planType ? 'Change Plan' : 'Upgrade'}
//             </button>
//             {subscription?.status === 'active' && !subscription.pendingAction && (
//               <button
//                 onClick={() => setShowCancelDialog(true)}
//                 className="text-red-500 hover:text-red-700"
//               >
//                 Cancel Subscription
//               </button>
//             )}
//             {subscription?.pendingAction === 'cancel' && (
//               <button
//                 onClick={handleReactivate}
//                 className="text-blue-500 hover:text-blue-700"
//               >
//                 Reactivate Subscription
//               </button>
//             )}
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           <div className="bg-gray-50 p-4 rounded">
//             <h3 className="font-semibold mb-2">Credits</h3>
//             <div className="space-y-1">
//               <p>Subscription Credits: {subscription?.credits.subscription || 0}</p>
//               <p>Purchased Credits: {subscription?.credits.purchased || 0}</p>
//               <p className="font-medium">
//                 Total Available: {(subscription?.credits.subscription || 0) + (subscription?.credits.purchased || 0)}
//               </p>
//             </div>
//             <button
//               onClick={() => navigate('/subscription/buy-credits')}
//               className="mt-4 text-blue-500 hover:text-blue-700"
//             >
//               Buy More Credits
//             </button>
//           </div>

//           <div className="bg-gray-50 p-4 rounded">
//             <h3 className="font-semibold mb-2">Billing Period</h3>
//             <div className="space-y-1">
//               <p>
//                 Current Period: {new Date(subscription?.currentPeriodStart).toLocaleDateString()} - {new Date(subscription?.currentPeriodEnd).toLocaleDateString()}
//               </p>
//               {subscription?.pendingAction === 'cancel' && (
//                 <p className="text-red-500">
//                   Cancels on {new Date(subscription.currentPeriodEnd).toLocaleDateString()}
//                 </p>
//               )}
//               {subscription?.pendingAction === 'downgrade' && (
//                 <p className="text-orange-500">
//                   Changes to {subscription.pendingPlan} on {new Date(subscription.currentPeriodEnd).toLocaleDateString()}
//                 </p>
//               )}
//             </div>
//           </div>

//           <div className="bg-gray-50 p-4 rounded">
//             <h3 className="font-semibold mb-2">Features</h3>
//             <ul className="space-y-1">
//               {subscription?.planType && PLAN_CONFIGS[subscription.planType].features.map((feature, index) => (
//                 <li key={index} className="flex items-center text-sm">
//                   <svg
//                     className="w-4 h-4 mr-2 text-green-500"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M5 13l4 4L19 7"
//                     />
//                   </svg>
//                   {feature}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Transaction History */}
//       <div className="bg-white rounded-lg shadow-md p-6">
//         <h2 className="text-xl font-bold mb-6">Transaction History</h2>

//         {transactions.length === 0 ? (
//           <p className="text-gray-500 text-center py-8">No transactions found</p>
//         ) : (
//           <>
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Invoice</th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {transactions.map((transaction) => (
//                     <tr key={transaction.id}>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                         {new Date(transaction.createdAt).toLocaleDateString()}
//                       </td>
//                       <td className="px-6 py-4 text-sm text-gray-900">
//                         {transaction.description}
//                         {transaction.metadata?.isDowngrade && (
//                           <span className="ml-2 text-orange-500">
//                             (Changes effective {new Date(transaction.metadata.effectiveDate).toLocaleDateString()})
//                           </span>
//                         )}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                         {formatCurrency(transaction.amount / 100)}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap">
//                         <span className={`px-2 py-1 text-xs font-semibold rounded-full
//                           ${transaction.status === 'completed'
//                             ? 'bg-green-100 text-green-800'
//                             : 'bg-gray-100 text-gray-800'}`}
//                         >
//                           {transaction.status}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                         {transaction.stripeInvoiceId && (
//                           <button
//                             onClick={() => handleDownloadInvoice(transaction.stripeInvoiceId)}
//                             disabled={downloadingInvoice === transaction.stripeInvoiceId}
//                             className="text-blue-500 hover:text-blue-700 disabled:opacity-50"
//                           >
//                             {downloadingInvoice === transaction.stripeInvoiceId ? 'Downloading...' : 'Download'}
//                           </button>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="flex justify-center mt-6">
//                 <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
//                   {Array.from({ length: totalPages }).map((_, i) => (
//                     <button
//                       key={i}
//                       onClick={() => setCurrentPage(i + 1)}
//                       className={`relative inline-flex items-center px-4 py-2 text-sm font-medium
//                         ${currentPage === i + 1
//                           ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
//                           : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
//                         } border`}
//                     >
//                       {i + 1}
//                     </button>
//                   ))}
//                 </nav>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Cancel Confirmation Dialog */}
//       <ConfirmationDialog
//         isOpen={showCancelDialog}
//         onClose={() => setShowCancelDialog(false)}
//         onConfirm={handleCancelSubscription}
//         title="Cancel Subscription"
//       >
//         <p>Are you sure you want to cancel your subscription? Your subscription will remain active until the end of your current billing period on {new Date(subscription?.currentPeriodEnd).toLocaleDateString()}.</p>
//       </ConfirmationDialog>
//     </div>
//   );
// };

// export default MembershipInfo;
